import { formatNumber } from '@/utils/number';

export const formatBatchAmount = (value: number): string => formatNumber(Math.round(value));
